import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import OverallSetup from "./routes/OverallSetup";
import AssessmentCategorySetup from "./routes/AssessmentCategorySetup";
import CumulativeScoreSetup from "./routes/CumulativeScoreSetup";
import GradeBoundarySetup from "./routes/GradeBoundarySetup";
import LocalGradesSetup from "./routes/LocalGradeSetup";
import OverallGradeSetup from "./routes/OverallGradeSetup";
import AssessmentTypes from "./routes/AssessmentTypes";
import Nomenclature from "./routes/Nomenclature";
import AggregateSetup from "./routes/AggregateSetup";

export default store => ({
  path: "grading-setup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    OverallSetup(store),
    AssessmentCategorySetup(store),
    CumulativeScoreSetup(store),
    GradeBoundarySetup(store),
    LocalGradesSetup(store),
    OverallGradeSetup(store),
    AssessmentTypes(store),
    Nomenclature(store),
    AggregateSetup(store),
  ],
});
